export default {
  namespaced: true,
  seproban: {
    title: "seproban",
    id_alarm: "id alarm",
    path: "path",
    order: "send order",
    is_send: "is sent",
    sent_at: "sent at",
    image: "Image",
    downloaded: "Downloaded",
    downloaded_at: "Downloaded at",
    sent_seproban: "Sent seproban",
    sent_seproban_at: "Sent seproban at",
    images: "Images",
    send_seproban: "Send to Seproban",
    fetching_images: "Fetching images...",
    capture_completed: "Image capture completed",
    uploading_images: "Uploading images...",
    upload_finished: "Image upload completed",
    no_images_available: "No images available for this camera.",
    sending: "Sending",
    total_images: "Total images",
    generated_images: "Generated",
    sent_images: "Sent",
    view_detail: "View details",
    all_downloaded_at: "All downloaded date",
    all_sent_at: "All sent date",
    image_details: "Seproban image details",
    event_id: "Seproban event ID",
    alarm_id: "Alarm ID",
    alarm_created_at: "Alarm creation date",
    unit: "Unit",
    first_download_at: "First download date",
    last_download_at: "Last download date",
    first_sent_at: "First sent date",
    last_sent_at: "Last sent date",
    send_rate: "Send rate",
    images_per_second: "images/s",
    download_date_range: "Download date range",
    sent_date_range: "Sent date range",
    generating_images: "Generating images...",
 }
}
